import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import "../css/ImageCarousel.css";
import leftWhiteIcon from "../../assets/images/dashboard-left-white.svg";
import leftOrengeIcon from "../../assets/images/dashboard-left-orenge.svg";
import rightWhiteIcon from "../../assets/images/dashboard-right-white.svg";
import rightOrengeIcon from "../../assets/images/dashboard-right-orenge.svg";
interface ImageCarouselProps {
  images: string[];
  title: string;
  subTitle: string;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  title,
  subTitle,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = () => {
    const el = scrollRef.current;
    if (el) {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }
  };

  useLayoutEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const update = () => updateScrollButtons();
    update();
    requestAnimationFrame(update);
    el.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [images]);

  const scrollEvents = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 200;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
      setTimeout(updateScrollButtons, 300);
    }
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const width = container.offsetWidth;
    const index = Math.round(scrollLeft / width);
    setCurrentIndex(index);
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="image-carousel-parenrt-container">
      <div className="header-container">
        <span>
          {title} <span style={{ color: "#FF6B35" }}>{subTitle}</span>
        </span>
        <div className="button-container">
          <img
            src={canScrollLeft ? leftOrengeIcon : leftWhiteIcon}
            alt="left-button"
            onClick={() => canScrollLeft && scrollEvents("left")}
          />
          <img
            src={canScrollRight ? rightOrengeIcon : rightWhiteIcon}
            alt="right-button"
            onClick={() => canScrollRight && scrollEvents("right")}
          />
        </div>
      </div>
      <div className="divider" />
      <div className="image-carousel-wrapper">
        <div className="image-carousel-scroll" ref={scrollRef}>
          {images.map((src, i) => (
            <div className="image-carousel-slide" key={i}>
              <img
                src={src}
                alt={`Slide ${i + 1}`}
                className="carousel-image"
                onLoad={updateScrollButtons}
              />
            </div>
          ))}
        </div>

        <div className="carousel-fixed-dot-indicators">
          {images.map((_, i) => (
            <span
              key={i}
              className={`carousel-dot ${i === currentIndex ? "active" : ""}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
